import type { PublicPriceCheckComponentProps } from './PublicPriceCheckComponent';

export const PublicPriceCheckComponent = {
    MountAsync: async (target: HTMLElement, props: PublicPriceCheckComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { PublicPriceCheckComponent } = await import('./PublicPriceCheckComponent');
        return await mountReactComponentAsync(target, PublicPriceCheckComponent, props);
    }
};
